import { Component, Injector } from '@angular/core';
import * as moment from 'moment-timezone';
import { PagedListingComponentBase, PagedRequestDto } from '@shared/paged-listing-component-base';
import { AssinaturaDto, AssinaturaServiceProxy } from '@shared/service-proxies/service-proxies';
import { StringUtils } from '@shared/helpers/StringUtils';
import { finalize } from 'rxjs/operators';
import { BsModalRef } from 'ngx-bootstrap/modal';

export class PagedAssinaturaRequestDto extends PagedRequestDto {
  public dataInicio: moment.Moment;
  public dataFim: moment.Moment;
  public userId: number;
}

@Component({
  selector: 'historico-assinatura',
  templateUrl: './historico-assinatura.component.html',
  styleUrls: ['./historico-assinatura.component.scss']
})

export class HistoricoAssinaturaComponent extends PagedListingComponentBase<AssinaturaDto> {

  protected request: PagedAssinaturaRequestDto = new PagedAssinaturaRequestDto();
  protected assinaturas: AssinaturaDto[] = [];
  public dataInicio: string = "";
  public dataFinal: string = "";

  constructor(
    injector: Injector,
    public bsModalRef: BsModalRef,
    private readonly _assinaturaService: AssinaturaServiceProxy
  ) {
    super(injector)
  }

  protected list(request: PagedAssinaturaRequestDto, pageNumber: number, finishedCallback: Function): void {
    request.userId = this.appSession.userId;
    request.dataFim = StringUtils.isNullOrEmpty(this.dataFinal) ? null : moment(this.dataFinal);
    request.dataInicio = StringUtils.isNullOrEmpty(this.dataInicio) ? null : moment(this.dataInicio);

    abp.ui.setBusy();
    this._assinaturaService.getAll(
      request.dataInicio,
      request.dataFim,
      request.userId,
      request.skipCount,
      request.maxResultCount
    ).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.assinaturas = result.items;
      this.totalItems = result.totalCount;
      this.showPaging(result, pageNumber);
    });
  }

  protected delete(entity: AssinaturaDto): void {
    return;
  }

  protected onDateChange(): void {
    this.refresh();
  }

  protected limparFiltro(): void {
    this.request.dataFim = null;
    this.request.dataInicio = null;
    this.dataFinal = null;
    this.dataInicio = null;
    this.refresh();
  }

  protected getValor(assinatura: AssinaturaDto) {
    return assinatura.tipoAssinaturaString == "Anual" ? assinatura.plano?.valorAnual : assinatura.plano?.valorMensal;
  }

}
